import React from 'react';
import './About.css'
import { FaMedal } from "react-icons/fa";
import { FaBookReader } from "react-icons/fa";
import { FaBalanceScale } from "react-icons/fa";



const About = () => {
    return(<div id='about'>


<div className="section section-4 bg-light">
<div className="container">
    <div className="row justify-content-center text-center mb-5">
        <div className="col-lg-5">
            <h2 className="font-weight-bold heading text-primary mb-4 hh2 h2">
            We are an esteemed IT training institute, providing superior education and training.
            </h2>
            <p className="text-black-50 p">
            We are empowering a new generation of innovators through transformative education at WillanTech academy. 
            WillanTech offers a diverse selection of education programs that appeal to people from all walks of life, from businesses with growing training needs to individuals seeking IT and related skills.
            </p>
        </div>
    </div>
    <div className="row justify-content-between mb-5">
        <div className="col-lg-7 mb-5 mb-lg-0 order-lg-2">
            <div className="img-about dots" data-aos="flip-right">
                <img src={"assets/images/about-img.png"} alt="" className="img-fluid" />
            </div>
        </div>
        <div className="col-lg-4">
            <div className="d-flex feature-h">
                <span className="wrap-icon me-3">
                <span className="icon-home2">
                <i class="fa-solid fa-house"><FaBalanceScale/></i>
                </span>
                </span>
                <div className="feature-text">
                    <h3 className="heading hh2 h3">Our Vision</h3>
                    <p className="text-black-50 p">
                    To equip innovative and envision a future where every graduate emerges as an excellent IT professional, capable of 
                    entrepreneurship in the IT sector
                    </p>
                </div>
            </div>

            <div className="d-flex feature-h">
                <span className="wrap-icon me-3">
                 <span className="icon-person">
                 <i class="fa-solid fa-user-tie"><FaBookReader/></i>
                 </span>
                </span>
                <div className="feature-text">
                    <h3 className="heading hh2 h3">Our Mission</h3>
                    <p className="text-black-50 p">
                    At WillanTech, we provide extensive IT education and training that empowers individuals to become problem solvers and critical thinkers 
                    in the digital era
                    </p>
                </div>
            </div>

            <div className="d-flex feature-h">
                <span className="wrap-icon me-3">
                <span className="icon-security">
                <i class="fa-solid fa-user-tie"><FaMedal/></i>
                </span>
                </span>
                <div className="feature-text">
                    <h3 className="heading hh2 h3">Our Core Values</h3>
                    <p className="text-black-50 p">
                    ✔ Recognition ✔ Excellence ✔ Innovation ✔ Integrity ✔ Service ✔ Student-Centric Approach
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div className="row section-counter mt-5">
        <div className="col-6 col-sm-6 col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay="300">
            <div className="counter-wrap mb-5 mb-lg-0">
                <span className="number"><span className="countup text-primary hh2">Projects</span></span>
                <span className="caption text-black-50">We Assign group projects that require collaboration and teamwork.
                This assessment component assesses students' ability to work effectively in a team, communicate, 
                delegate tasks, and deliver a cohesive solution.</span>
            </div>
        </div>
        <div className="col-6 col-sm-6 col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay="400">
            <div className="counter-wrap mb-5 mb-lg-0">
                <span className="number"><span className="countup text-primary hh2">Internships</span></span>
                <span className="caption text-black-50">We Offer opportunities for students to engage in industry internships,
                 where they work on real-world IT projects under the guidance of industry professionals.
                 This allows them to apply their skills and knowledge in a professional setting.
                </span>
            </div>
        </div>
        <div className="col-6 col-sm-6 col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay="500">
            <div className="counter-wrap mb-5 mb-lg-0">
                <span className="number"><span className="countup text-primary hh2">Practicals</span></span>
                <span className="caption text-black-50">We assess students' ability to apply their knowledge and skills to real-world IT scenarios.
                This can include tasks such as configuring network devices, troubleshooting hardware or software issues, or performing system installations and upgrades.</span>
            </div>
        </div>
        <div className="col-6 col-sm-6 col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay="600">
            <div className="counter-wrap mb-5 mb-lg-0">
                <span className="number"><span className="countup text-primary hh2">Quizzes</span></span>
                <span className="caption text-black-50">We Create online quizzes or knowledge checks to assess students' understanding of specific IT topics. These can be used
                 for regular assessments, reinforcement of key concepts, or self-paced learning.</span>
            </div>
        </div>
    </div>
</div>
</div><br /><br />

        <div className="section sec-h">
            <div className="row justify-content-center footer-cta" data-aos="fade-up">
                <div className="col-lg-7 mx-auto text-center">
                    <h2 className="mb-4 hh2">Start exploring our listings today and find your desired courses</h2>
                    <span class="line-bar">...</span><br />
        </div>
      </div>
    </div>


    </div>)
};


export default About;
